import { v4 as uuid } from "uuid";
import { fields } from "./fields";
import { headerCheckboxObject } from "@monorepo/utils/src/variables/headerCheckboxValue";
import { authorities } from "@monorepo/utils/src/authorities/authorities";

export const tableHeaders = [
  headerCheckboxObject(),
  {
    text: "Заголовок",
    tooltip: "Заголовок описи дел",
    defaultWidth: 200,
    value: fields.HEADER,
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Доступные действия",
    tooltip: "Доступные пользователю действия",
    defaultWidth: 200,
    value: fields.USER_AVAILABLE_ROLES,
    sortField: "availableAction",
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "№ описи дел",
    tooltip: "Номер описи дел в ОИК",
    defaultWidth: 200,
    value: fields.NUMBER,
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Год",
    tooltip: "Год, за который сформирована опись дел",
    defaultWidth: 100,
    value: fields.YEAR,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Статус",
    tooltip:
      "Статус описи дел может принимать значения: Новый, Частично согласован, Полностью согласован, Утверждено решение принять проект описи дел," +
      " Утверждено решение не принимать проект описи электронных дел, Удален, Принято в ЦХЭД",
    defaultWidth: 150,
    value: fields.STATUS,
    sortField: "commissionStatus",
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "ОИК",
    tooltip: "Краткое наименование ОИК",
    defaultWidth: 230,
    value: fields.OIK_SHORT_NAME,
    linkRights: [authorities.OIK_LIST],
    isLink: true,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Фонд",
    tooltip: "Номер фонда",
    defaultWidth: 110,
    value: fields.FUND_NUMBER,
    linkRights: [authorities.FUND_LIST],
    isLink: true,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Вид",
    tooltip: "Вид описи дел может принимать значения «Больше или равно 10 лет», «Постоянно», «По личному составу»",
    defaultWidth: 130,
    value: fields.CATEGORY,
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Тип",
    tooltip: "Тип описи дел может принимать значения «Передача документов», «Изменение сроков хранения документов»",
    defaultWidth: 130,
    value: fields.KIND,
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Дата утверждения описи дел",
    tooltip: "Дата утверждения описи дел",
    defaultWidth: 250,
    value: fields.APPROVE_DATE,
    isLink: false,
    isSorted: true,
    sortField: "approvedDate",
    isHandle: true,
    id: uuid(),
  },
  {
    text: "Дата поступления в ЦХЭД",
    tooltip: "Дата поступления в ЦХЭД",
    defaultWidth: 250,
    value: fields.CREATE_DATE_TIME,
    isLink: false,
    isSorted: true,
    isHandle: true,
    id: uuid(),
  },
];
